<template>
  <div v-if="isOpen" class="modal-container">
    <div class="fixed inset-0 bg-background/80 backdrop-blur-sm z-40"></div>
    <div
      class="modal-content w-full max-w-md relative bg-card m-auto flex-col flex rounded-lg z-50 shadow-xl border border-border"
    >
      <div class="w-full border-b border-border mb-4 px-6 py-4">
        <h2 class="text-[18px] text-foreground font-medium">
          Are you sure you want to delete
          <span class="font-bold">{{ workspaceName }}</span
          >?
        </h2>
      </div>

      <form @submit.prevent="deleteWorkspace" class="overflow-y-auto px-6">
        <div class="mb-4">
          <p class="text-sm text-muted-foreground mb-4">
            This action cannot be undone. This will permanently delete the hub
            and all associated data.
          </p>
          <label class="block text-sm font-medium text-foreground">
            To confirm, type "delete" in the box below
          </label>
          <input
            type="text"
            v-model="confirmationText"
            placeholder="Type delete"
            class="mt-1 block w-full px-3 py-2 bg-muted border border-border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-red-500/50 focus:border-red-500 sm:text-sm text-foreground placeholder:text-muted-foreground/50"
            required
          />
        </div>
        <div class="flex justify-end gap-3 mb-6">
          <button
            type="button"
            class="py-2 px-4 bg-transparent border border-border text-foreground rounded-full hover:bg-muted transition-colors text-sm"
            @click="$emit('close')"
          >
            Cancel
          </button>
          <button
            type="submit"
            :class="[
              'py-2 px-4 h-[40px] text-white rounded-full text-sm font-medium transition-all shadow-sm',
              confirmationText === 'delete'
                ? 'bg-red-600 hover:bg-red-700'
                : 'bg-muted cursor-not-allowed opacity-50 text-muted-foreground',
            ]"
            :disabled="confirmationText !== 'delete'"
          >
            Delete Hub
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeleteWorkspaceModal",
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    workspaceId: {
      type: [String, Number],
      required: true,
    },
    workspaceName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      confirmationText: "",
    };
  },
  methods: {
    deleteWorkspace() {
      if (this.confirmationText === "delete") {
        this.$emit("confirm-delete", this.workspaceId);
        this.confirmationText = "";
      }
    },
  },
  watch: {
    isOpen(newVal) {
      if (!newVal) {
        this.confirmationText = "";
      }
    },
  },
};
</script>

<style scoped>
.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 60;
}

.modal-content {
  max-height: 90vh;
  overflow-y: auto;
  margin: 20px;
  z-index: 70;
}
</style>
